import { render, staticRenderFns } from "./YuanbaoAuthorRule.vue?vue&type=template&id=7f03f0c6&scoped=true&"
import script from "./YuanbaoAuthorRule.vue?vue&type=script&lang=js&"
export * from "./YuanbaoAuthorRule.vue?vue&type=script&lang=js&"
import style0 from "./YuanbaoAuthorRule.vue?vue&type=style&index=0&id=7f03f0c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f03f0c6",
  null
  
)

export default component.exports